import React from "react"
import PropTypes from 'prop-types'

import SelectGenericNew from "../../../../gd-ui/select-generic-new/select-generic-new"
import FieldRating_DropdownOption from "../components/dropdown/popover-option";
import FieldRating_DropdownValueNotEmpty from "../components/dropdown/value-not-empty";

const debug = false
// const debug = "RatingConditionForm"

export default class FieldRating_AutomationConditionForm extends React.Component<any,any> {

    static propTypes = {
        field           : PropTypes.object,
        config          : PropTypes.object,

        options         : PropTypes.array,

        onChangeCallback: PropTypes.func,
    }

    constructor(props:any) {
        super(props)

        this.state = {
            value: _.get(props.config, 'value', null)
        }
    }

    onChangeToValue = (option:any) => {
        const value = option ? option.value : null

        this.setState({
            value
        }, ()=>{
            this.props.onChangeCallback({value})
        })
    }

    render() {
        debug && console.log(debug, 'render', this.state)

        const labelClasses = Classes("label", {
            'w-100': this.props.field.isCustom
        })

        return (
            <div className="flex-row-left-top">
                <div className={labelClasses}>is</div>
                <SelectGenericNew className                     = "selector w-180"
                                  options                       = {this.props.field.getAutomationOptions()}
                                  value                         = {this.state.value}
                                  popoverScrollContainerClasses = "max-h-200"
                                  noValueOption                 = {true}
                                  isSearchable                  = {true}
                                  valueComponent                = {(props:any)=><FieldRating_DropdownValueNotEmpty scale={this.props.field.scale} {...props}/>}
                                  popoverOptionComponent        = {(props:any)=><FieldRating_DropdownOption scale={this.props.field.scale} {...props}/>}
                                  disabled                      = {this.props.config.disabled}
                                  onChange                      = {this.onChangeToValue}/>
            </div>
        )
    }
}